export const template3: SimpleProjectServiceAPI.ConfigurationDataDto = {
  root: '75d093dc-a8fd-4d1c-a957-20a6778302c2',
  storeId: '601a8002abc3a6544a187366',
  articles: [
    {
      id: '75d093dc-a8fd-4d1c-a957-20a6778302c2',
      number: '920006 1000',
      colors: [
        {
          ralValue: 'RAL 7035',
          affectedMaterial: 'config_ral_primary',
        },
      ],
      requiredLightingArticlesIds: [],
    },
    {
      id: 'fd7ec84a-fbf2-4460-a2ec-ceb33306a1c3',
      number: '928010 200',
      colors: [
        {
          ralValue: 'RAL 7035',
          affectedMaterial: 'config_ral_primary',
        },
      ],
      requiredLightingArticlesIds: [],
    },
    {
      id: 'c3c9b63f-2b0c-4381-aa6c-d75b91202dd7',
      number: '928443 1000',
      colors: [
        {
          ralValue: 'RAL 7035',
          affectedMaterial: 'config_ral_primary',
        },
      ],
      requiredLightingArticlesIds: [],
    },
  ],
  slots: [
    {
      id: 'a7cfaa27-580a-4f89-93da-846d43f7b855',
      type: 'PAIR',
      parentId: '75d093dc-a8fd-4d1c-a957-20a6778302c2',
      name: 'supportColumnBase',
      childId: 'fd7ec84a-fbf2-4460-a2ec-ceb33306a1c3',
    },
    {
      id: '1f3838c3-417d-4303-a030-dd9f5b1f73af',
      type: 'SINGLE',
      parentId: '75d093dc-a8fd-4d1c-a957-20a6778302c2',
      name: 'structureDividerBase',
      alignment: null,
    },
    {
      id: '2cb2a83a-c5b3-4a64-804c-d23608da2cae',
      type: 'LINE',
      parentId: '75d093dc-a8fd-4d1c-a957-20a6778302c2',
      name: 'tabletopSubstructure',
      children: [],
      axis: 'X',
      length: 920,
    },
    {
      id: '99ed7d93-3287-4efe-9381-6ac6a15258a5',
      type: 'SINGLE',
      parentId: 'fd7ec84a-fbf2-4460-a2ec-ceb33306a1c3',
      name: 'columnThreadedBushBottom',
      xIndex: 1,
      alignment: 'left',
    },
    {
      id: '9917c380-54ae-42a4-9c4f-340d7dbf0ca0',
      type: 'SINGLE',
      parentId: 'fd7ec84a-fbf2-4460-a2ec-ceb33306a1c3',
      name: 'columnThreadedBushBottom',
      xIndex: 1,
      alignment: 'right',
    },
    {
      id: '42bbf4e2-28c1-4521-9f2a-9dc40bf9da7b',
      type: 'SINGLE',
      parentId: 'fd7ec84a-fbf2-4460-a2ec-ceb33306a1c3',
      name: 'leftColumnSuspension',
      childId: 'c3c9b63f-2b0c-4381-aa6c-d75b91202dd7',
      xIndex: 2,
      alignment: null,
    },
    {
      id: 'a01c3ecf-d9f1-4040-aa61-fe2a4d06868e',
      type: 'SINGLE',
      parentId: 'fd7ec84a-fbf2-4460-a2ec-ceb33306a1c3',
      blockedBy: 'c3c9b63f-2b0c-4381-aa6c-d75b91202dd7',
      name: 'leftColumnSuspension',
      xIndex: 1,
      alignment: null,
    },
    {
      id: '41ff0281-6f18-4a1a-ad96-b9ec520c45bd',
      type: 'SINGLE',
      parentId: 'fd7ec84a-fbf2-4460-a2ec-ceb33306a1c3',
      blockedBy: 'c3c9b63f-2b0c-4381-aa6c-d75b91202dd7',
      name: 'rightColumnSuspension',
      xIndex: 1,
      alignment: null,
    },
    {
      id: 'b19ed6ef-5a35-40f4-a0c3-519ae950ed9f',
      type: 'SINGLE',
      parentId: 'fd7ec84a-fbf2-4460-a2ec-ceb33306a1c3',
      blockedBy: 'c3c9b63f-2b0c-4381-aa6c-d75b91202dd7',
      name: 'leftColumnSuspension',
      xIndex: 0,
      alignment: null,
    },
    {
      id: 'b1967604-2dd3-4717-b566-bc87d9efc7fb',
      type: 'SINGLE',
      parentId: 'fd7ec84a-fbf2-4460-a2ec-ceb33306a1c3',
      blockedBy: 'c3c9b63f-2b0c-4381-aa6c-d75b91202dd7',
      name: 'rightColumnSuspension',
      xIndex: 0,
      alignment: null,
    },
    {
      id: '415178cd-6820-42f6-acd6-9cd268eae501',
      type: 'SINGLE',
      parentId: 'fd7ec84a-fbf2-4460-a2ec-ceb33306a1c3',
      blockedBy: 'c3c9b63f-2b0c-4381-aa6c-d75b91202dd7',
      name: 'rightColumnSuspension',
      xIndex: 2,
      alignment: null,
    },
    {
      id: '02478360-31af-40d1-85d2-e14bbe88fc1b',
      type: 'SINGLE',
      parentId: 'fd7ec84a-fbf2-4460-a2ec-ceb33306a1c3',
      blockedBy: 'c3c9b63f-2b0c-4381-aa6c-d75b91202dd7',
      name: 'columnThreadedBushBottom',
      xIndex: 0,
      alignment: 'left',
    },
    {
      id: '29a8aeea-3bda-4b41-9609-1fdb2412d440',
      type: 'SINGLE',
      parentId: 'fd7ec84a-fbf2-4460-a2ec-ceb33306a1c3',
      blockedBy: 'c3c9b63f-2b0c-4381-aa6c-d75b91202dd7',
      name: 'columnThreadedBushBottom',
      xIndex: 0,
      alignment: 'right',
    },
  ],
  requiredConnectArticles: [],
  requiredLightingArticles: [],
  rootArticleName: 'mLevel workstation 1000mm',
  socketType: 'F',
  theme: {
    primaryColor: 'RAL 7035',
    secondaryColor: 'RAL 7016',
  },
  version: 5,
};
